import { memberApiV2 } from '@lib/api';
import { actions as userActions } from '@store/ducks/users';
import React from 'react';
import { IUserProviderItem } from './../../types/provider.types';
import { useAppDispatch, useAppSelector } from './redux';

function useProviderStore() {
  const dispatch = useAppDispatch();
  const providerId = useAppSelector((state) => state.users.currentProvider?.id)!;

  const setCurrentProvider = React.useCallback((provider: IUserProviderItem) => {
    dispatch(userActions.setProviderId(provider.provider.id));
    dispatch(userActions.setCurrentProvider(provider.provider));
    dispatch(userActions.setCurrentPermissions(provider.role.permission));

    /**
     * Global header is set on provider change to ensure all request having provider id,
     * in headers to prevent the need for developer to add.
     * !Please don't forget to add provider id in get request
     */
    memberApiV2.setGlobal(['headers', 'provider-id'], provider.provider.id);
  }, []);

  return {
    providerId,
    setCurrentProvider,
  };
}

export default useProviderStore;
